<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <h2>
          Predogled:
        </h2>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="print"
        >
          Tiskaj
          <v-icon right dark>mdi-printer</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="save"
        >
          Shrani
          <v-icon right dark>mdi-content-save-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="send"
          v-if="false"
        >
          Poslji
          <v-icon right dark>mdi-email-send-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          @click="closeWindow"
        >
          Prekliči
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10" offset="1" md="8" offset-md="2">
        <pdf class="pdf-preview" :src="`data:application/pdf;base64,${base64pdf}`"></pdf>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import printJS from 'print-js'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  props: ['dateTo', 'dateFrom', 'clientName'],
  mixins: [
    asyncDataStatus
  ],
  components: {
    pdf
  },
  data () {
    return {
      base64pdf: null,
      fileName: ''
    }
  },
  methods: {
    ...mapActions('writeoffForms', ['getPdf']),
    print () {
      printJS({ printable: this.base64pdf, type: 'pdf', base64: true })
    },
    save () {
      const linkSource = `data:application/pdf;base64,${this.base64pdf}`
      const downloadLink = document.createElement('a')

      downloadLink.href = linkSource
      downloadLink.download = this.fileName
      downloadLink.click()
    },
    send () {

    },
    closeWindow () {
      window.close()
    }
  },
  created () {
    this.getPdf({
      filters: {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        client: this.clientName
      }
    })
      .then(response => {
        const responseItems = response.data.items[0]
        this.asyncDataStatus_fetched()
        this.base64pdf = responseItems.data
        this.fileName = responseItems.filename
      })
      .catch(anErr => {
        console.log(anErr)
        this.$notify({
          type: 'error',
          text: 'Prišlo je do napake pri liste prevzemnic.'
        })
      })
  }
}
</script>

<style scoped>
.pdf-preview {
  border: 1px solid black;
}
</style>
